import { SelectOption } from './types';

export enum AccidentTypeEnum {
    ALL = 0,
    WORK_ACCIDENT = 1,
    WORK_ACCIDENT_IN_ITINERE = 3,
    PROFESSIONAL_DISEASE = 6
}

export const ACCIDENT_TYPE_OPTIONS: SelectOption[] = [
    { id: AccidentTypeEnum.ALL, label: 'Todos' },
    { id: AccidentTypeEnum.WORK_ACCIDENT, label: 'Accidente de Trabajo' },
    { id: AccidentTypeEnum.WORK_ACCIDENT_IN_ITINERE, label: 'Accidente de Trabajo In Itinere' },
    { id: AccidentTypeEnum.PROFESSIONAL_DISEASE, label: 'Enfermedad Profesional' }
];

export enum SiniestroStatusEnum {
    OPEN = 1,
    PENDING = 2,
    FINISHED = 3,
    CANCELLED = 4
}

export const SINIESTRO_STATUS_OPTIONS: SelectOption[] = [
    { id: SiniestroStatusEnum.OPEN, label: 'Abierto' },
    { id: SiniestroStatusEnum.PENDING, label: 'Pendiente' },
    { id: SiniestroStatusEnum.FINISHED, label: 'Finalizado' },
    { id: SiniestroStatusEnum.CANCELLED, label: 'Cancelado' }
];

export enum SrtStatusEnum {
    ALL = 0,
    PENDING = 1,
    EN_PROCESO = 2,
    CARGADO = 3,
    EXPORTADO = 4
}

export const SRT_STATUS_OPTIONS: SelectOption[] = [
    { id: SrtStatusEnum.ALL, label: 'Todos' },
    { id: SrtStatusEnum.PENDING, label: 'Pendiente' },
    { id: SrtStatusEnum.EN_PROCESO, label: 'En proceso' },
    { id: SrtStatusEnum.CARGADO, label: 'Cargado' },
    { id: SrtStatusEnum.EXPORTADO, label: 'Exportado' }
];

export const INVESTIGATION_OPTIONS: SelectOption[] = [
    { id: 0, label: 'Todos' },
    { id: 1, label: 'Si', extra: { value: true } },
    { id: 2, label: 'No', extra: { value: false } }
];

export const LUGAR_OCURRENCIA_OPTIONS: SelectOption[] = [
    { id: 0, label: 'Todos' },
    { id: 1, label: 'Completo', extra: { value: 'COMPLETO' } },
    { id: 2, label: 'Incompleto', extra: { value: 'INCOMPLETO' } }
];

export const buildComplaintYearOptions = (): SelectOption[] => {
    const currentYear = new Date().getFullYear();
    const years: SelectOption[] = [{ id: 0, label: 'Todos' }];
    for (let year = currentYear; year >= 1980; year--) {
        years.push({ id: year, label: String(year) });
    }
    return years;
};
